<template>
  <vue-scroll>
    <rabbey-toolbox
      filter-placeholder="Buscar por nombre de rol"
      filterables
      @filter-search="search = $event"
    />

    <rabbey-table2
      index-url="/api/rolmanager/getall"
      key-search="RolName"
      :search="search"
      :columns="columns"
      :actions="actions"
      @rtable-push-action="handleCommand"
    />

    <DrawerAssignerUserRole ref="assigner_user" />
    <DrawerRoleViewUsers ref="view_users" />
  </vue-scroll>
</template>

<script>
import DrawerAssignerUserRole from "@/components/role_manager/DrawerAssignerUserRole";
import DrawerRoleViewUsers from "@/components/role_manager/DrawerRoleViewUsers";

export default {
  name: "RoleManager",
  components: {
    DrawerAssignerUserRole,
    DrawerRoleViewUsers
  },
  data() {
    return {
      search: "",
      columns: [
        {
          prop: "RolId",
          name: "NO",
          fixed: true,
          width: 85
        },
        {
          prop: "RolName",
          name: "Nombre",
          minWidth: 250
        },
        {
          prop: "UsersCount",
          name: "Asignados",
          width: 120,
          sortable: true
        }
      ],
      actions: [
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit"
        },
        {
          icon: "el-icon-delete",
          label: "Eliminar",
          command: "delete"
        },
        {
          icon: "el-icon-plus",
          label: "Agregar usuario",
          command: "add-user"
        },
        {
          icon: "el-icon-plus",
          label: "Ver usuarios",
          command: "view-users"
        }
      ]
    };
  },
  methods: {
    handleCommand(action) {
      if (action.command === "add-user") {
        this.$refs.assigner_user.currentRole = action.row;
        this.$refs.assigner_user.drawer = true;
      } else if (action.command === "view-users") {
        this.$refs.view_users.show(action.row);
      }
    }
  }
};
</script>

<style></style>
